import { useState } from "react";

import Button from "components/v1/Button";
import TableBuyerArchived from "components/molecules/buyer-match/table-buyer-archived";

// Assets
import IMagnifier from "assets/i-magnifier.js";
import IArrowShortail from "assets/i-arrow-shortail.js";

// Ctx
import { useBuyerMatchCtx } from "contexts/buyer-match";
import { useDebounce } from "hooks/useDebounce";

const ListArchivedBuyer = () => {
  const [search, setSearch] = useState("");

  const {
    listCustomer,
    isLoadingListCustomer,
    setIsOpenDetailBuyer,
    setSelectedLeadId,
    setListCustomerParams,
    listCustomerParams,
    countData,
    totalPage,
  } = useBuyerMatchCtx();

  const { debounceFn } = useDebounce({
    onChange: (query) => {
      setListCustomerParams({
        ...listCustomerParams,
        q: query,
      });
    },
    delay: 500,
  });

  return (
    <>
      <div className="min-h-[calc(100vh-81px-73px-48px)] p-4 rounded-[4px] bg-white">
        <div className="flex items-center justify-between gap-[12px] border-b-[0.5px] border-solid border-[#D8D8D9] py-2">
          <a href="/buyer-match">
            <Button
              icon={IArrowShortail}
              type="secondary"
              iconColor="#252526"
              text="Kembali"
            />
          </a>
        </div>

        <div className="flex items-center justify-between py-2">
          <h3 className="text-[17px] leading-[21px] tracking-[-0.4px] font-inter-semibold text-[#252526]">Arsip</h3>

          <div className="h-[32px] p-2 flex justify-center items-center gap-1 rounded-[4px] border-[1px] border-solid border-[#D8D8D9]">
            <IMagnifier />
            <input
              className="h-[24px] py-2 text-[11px] leading-[17px] tracking-[-0.4px] font-inter text-[#252526] placeholder:text-[#808285]"
              placeholder="Cari customer berdasarkan nama"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                debounceFn(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="overflow-x-auto">
          <TableBuyerArchived
            data={listCustomer?.data?.data ?? []}
            isLoading={isLoadingListCustomer}
            setListCustomerParams={setListCustomerParams}
            listCustomerParams={listCustomerParams}
            isSearch={!!search}
            countData={countData}
            totalPage={totalPage}
            handleOpenModal={(id) => {
              setSelectedLeadId(id);
              setIsOpenDetailBuyer(true);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ListArchivedBuyer;
